import { CreateRelationshipsRequestBodyDTO } from '@ketch-com/figurehead'
import { CreateRelationshipInitialValues } from './getInitialValues'

export const mapFormValuesToFormData = (values: CreateRelationshipInitialValues): CreateRelationshipsRequestBodyDTO => {
  return {
    foreignKey: values.relations.map(relation => relation.foreignKey!),
    primaryKey: values.relations.map(relation => relation.primaryKey!),
  }
}
